import { useCallback, useMemo } from "react";
import { Config } from "src/Utils/ConfigService/LoadConfig";
import { v1 } from "src/Utils/ApiVersions";
import { usePutRequest } from "../ApiWrappers/usePutRequest";
import { useDeleteRequest } from "../ApiWrappers/useDeleteRequest";
import { logger } from "src/Utils/LoggerService/LoggerService";

export const useClinicLogo = () => {
    const { putRequest, reqestError: uploadError, reqestLoading: uploadLoading, reqestResponse: uploadResponse } = usePutRequest();
    const { deleteRequest, requestError: deleteError, requestLoading: deleteLoading, requestResponse: deleteResponse } = useDeleteRequest();
    const baseUrl = useMemo(() => Config.GetConfigData().serviceUrl, []);
    const getRequestUrl = useCallback((clinicId: string) => `${baseUrl}api/${v1}/clinic/${clinicId}/logo`, [baseUrl]);

    const uploadClinicLogo = useCallback((logo: File, clinicId: string) => {
        logger.logInformation(`A request has been submitted to upload/replace the clinic logo for clinic ${clinicId}.`);
        const formData = new FormData();
        formData.append('logo', logo);
        putRequest<FormData>(formData, getRequestUrl(clinicId));
    }, [putRequest, getRequestUrl]);

    const deleteClinicLogo = useCallback((clinicId: string) => {
        logger.logInformation(`A request has been submitted to delete the clinic logo for clinic ${clinicId}.`);
        deleteRequest(getRequestUrl(clinicId));
    }, [deleteRequest, getRequestUrl]);

    return { uploadClinicLogo, uploadResponse, uploadLoading, uploadError, deleteClinicLogo, deleteResponse, deleteLoading, deleteError };
};
